<template>
  <div
    :class="`bg-primary SisrAccess row container-layout h-100 ${
      darkMode ? 'DARK_MODE' : ''
    }`"
  >
    <router-view :darkMode="darkMode" />
  </div>
</template>

<script>
import { layoutMixin } from "../../libs/mixins/layouts";

export default {
  mixins: [layoutMixin],
};
</script>
